import date from "date-and-time";
import { useGlobalStore } from "@/store/global";
import { ref, nextTick } from "vue";

const globalStore = useGlobalStore();

const vesselDate = "MM/DD/YYYY";
const vesselTime = "HH:mm";

const formatter = (dateString: string, format?: string): string => {
  const dateTime = new Date(removeOffsetFromDateString(dateString));
  const formattedDate = date.format(dateTime, format ?? vesselDate);
  const formattedTime = date.format(dateTime, format ?? vesselTime);
  return `${formattedDate} - ${formattedTime}`;
};

const removeOffsetFromDateString = (dateStr: string): string => {
  const format = dateStr.substring(0, 16);
  return format;
};
const printAll = ref(false);

export const downloadPDF = (vesselLists: any[], columnHeaders: any[]): any => {
  printAll.value = true;
  const columnName: Record<string, string> = columnHeaders.reduce(
    (acc: Record<string, string>, item: any): Record<string, string> => {
      acc[item.id] = item.label;
      return acc;
    },
    {}
  );
  //  Filtering data which not allowed in config for the users
  const filteredVesselSchedules = vesselLists.map((item: any): any => {
    const filteredItem: any = {};
    const transformedItem = { ...item }; // Clone item to avoid mutating original

    if (!item.gateOpenDateTimeLocal || item.gateOpenDateTimeLocal !== item.startReceiveDateTimeLocal) {
      transformedItem.gateOpenDateTimeLocal = item.startReceiveDateTimeLocal || "";
    }

    if (!item.docCutOff || item.docCutOff !== item.hazardousCutoffDateTimeLocal) {
      transformedItem.docCutOff = item.hazardousCutoffDateTimeLocal || "";
    }
    if (!item.shippingLineOperator || item.shippingLineOperator !== item.vesselOperator) {
      transformedItem.shippingLineOperator = item.vesselOperator ? item.vesselOperator.toUpperCase() : "";
    }
    if (!item.vesselEta || item.vesselEta !== item.expectedTimeArrivalDateTimeLocal) {
      transformedItem.vesselEta = item.expectedTimeArrivalDateTimeLocal || "";
    }
    if (!item.appointmentDateTimeLocal || item.appointmentDateTimeLocal !== item.roadGateAppointmentDateTimeLocal) {
      transformedItem.appointmentDateTimeLocal = item.roadGateAppointmentDateTimeLocal || "No";
    }
    if (!item.vesselEtd || item.vesselEtd !== item.estimatedDepartureDateTimeLocal) {
      transformedItem.vesselEtd = item.estimatedDepartureDateTimeLocal || "";
    }
    if (!item.vesselType || item.vesselType === "") {
      transformedItem.vesselType = item.vesselClassification || "";
    }

    // Only copy allowed keys
    Object.keys(transformedItem).forEach((key) => {
      if (columnName[key]) {
        filteredItem[key] = transformedItem[key];
      }
    });

    return filteredItem;
  });
  //
  const headers = Object.keys(filteredVesselSchedules[0]);
  // Map headers to display names
  const displayHeaders = headers.map((header): any => columnName[header] || header);
  nextTick((): void => {
    // Generate HTML content
    let htmlContent = "<html><head><title>PDF</title>";
    htmlContent += "<style>";
    htmlContent += "@page { size: landscape; margin: 20mm; }"; // Landscape orientation
    htmlContent += "@media print {";
    htmlContent += "  body { overflow: hidden; }";
    htmlContent += "}";
    htmlContent += "th, td { border: 1px solid black; padding: 8px; text-align: left; }";
    htmlContent += "th { background-color: #f2f2f2; }";
    htmlContent += "table { width: 100%; border-collapse: collapse; height: fit-content; overflow: auto; }";
    htmlContent += "tr:nth-child(even) { background-color: #dddddd; }";
    htmlContent += "</style>";
    htmlContent += "</head><body>";
    htmlContent += "<table><thead><tr>";
    displayHeaders.forEach((header): void => {
      htmlContent += `<th>${header}</th>`;
    });
    htmlContent += "</tr></thead><tbody>";
    filteredVesselSchedules.forEach((item): void => {
      htmlContent += "<tr>";
      headers.forEach((header): void => {
        let value = item[header];

        if (typeof value === "boolean") {
          value = value ? globalStore.sitecoreData.common.yes : globalStore.sitecoreData.common.no;
        } else if (
          header.includes("Date") ||
          header === "vesselEta" ||
          header === "docCutOff" ||
          header === "vesselEtd"
        ) {
          value = value && value != "" && value != "No" ? formatter(value) : value;
        } else {
          value = `${String(value).replace(/"/g, '""')}`;
        }
        htmlContent += `<td>${value}</td>`;
      });
      htmlContent += "</tr>";
    });
    htmlContent += "</tbody></table>";
    htmlContent += "</body></html>";

    // Create a temporary iframe to print content
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    doc?.open();
    doc?.write(htmlContent);
    doc?.close();
    iframe.contentWindow?.focus();
    iframe.contentWindow?.print();
    // Clean up iframe after printing
    document.body.removeChild(iframe);
  });
};
